import React from 'react';
import { GameStateProvider } from '../../components/WorkingChessLogic/GameStateContext';
import ViewGameMobile from '../pages/ViewGameMobile.js';

const ViewGameRoute = () => {
  return (
    <GameStateProvider>
      <ViewGameMobile />
    </GameStateProvider>
  );
};

export default ViewGameRoute;